// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a5152bab","806":"12cd7792"}[chunkId] + ".chunk.js";
};